
import { useEffect } from 'react'
import { classes, style, stylesheet } from 'typestyle'

import { GLOBAL_CONTENTS } from '../../../common/global-contents'
import { withRouter } from '../../../contexts/with-router'

/* Hooks ======================================================================================== */
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'
import useArray from '../../../hooks/use-array'

/* Components =================================================================================== */
import Skeleton from '../../../components/skeleton'
import { AsyncSelect } from '../../../modules/fields/async-select'
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Line } from '../../../components/line'
import { Loader } from '../../../components/loader'
import { Modal } from '../../../components/modal'
import { Notification } from '../../../components/notification'
import { Text } from '../../../components/text/text.component'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../../components/style-class/style-class.utils'
import { mb4 } from '../../../styles/styleset/margin/mb4'
import { mb8 } from '../../../styles/styleset/margin/mb8'
import { mr4 } from '../../../styles/styleset/margin/mr4'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { p12 } from '../../../styles/styleset/padding/p12'
import { pt4 } from '../../../styles/styleset/padding/pt4'

Modal.add(
  'AccessManager',
  withRouter((props: any) => {
    const { to } = props

    const [local] = useLocal()
    const [patch, $patch] = useFetch({ body: { access: [] } }, { url: to.url })
    const [values, $values] = useArray<any>([])

    useEffect(() => {
      if (patch.mounted) {
        $patch.get({ search: { lookups: [{ key: 'body.access$.id' }] } }).then((payload: any) => {
          $values.set(payload.body.access || [])
        })
      }
    }, [patch.mounted])

    return (
      <Box onClick={props.handleContentClick} rounded minWidth={300}>
        <Box className={classes(p12)} baseline="none">
          <Text size="md">Manage who can access</Text>
        </Box>
        <Line />
        <Box className={classes(p12)} baseline="none" row>
          <Loader
            loaded={patch.meta.isLoading !== undefined}
            skeleton={
              <Box row>
                <Skeleton width={60} height={14} className={mb8} />
                <Skeleton width={'100%'} height={32} className={mb8} />
                <Line className={mb8} />
                <Skeleton width={100} height={28} />
              </Box>
            }
            component={
              <>
                <AsyncSelect
                  fieldModel={{
                    label: 'Team Member',
                    placeholder: 'Start searching by typing here',
                    apiUrl: 'a/groups/{{groupId}}/base/team/table',
                    labelKey: 'body.user.id.body.fullName',
                    searchKey: 'body.user.id.body.fullName',
                    filterKey: 'body.user.id.id',
                    valueKey: 'id',
                    lookups: [{ key: 'body.user.id' }],
                  }}
                  values={values.map((value: any) => {
                    return { body: { user: { id: { id: value.id.id } } } }
                  })}
                  disableClose={true}
                  resetOnSelect={true}
                  multiSelect={true}
                  onChange={(data: any) => {
                    if (!values.some((a: any) => a.id.id === data)) {
                      $values.push({ id: data })
                    } else {
                      $values.set((prev: any) => {
                        const newValue = [...prev]
                        const index = values.findIndex((a: any) => a.id.id === data)
                        newValue.splice(index, 1)

                        return newValue
                      })
                    }
                  }}
                  fixed={false}
                />
                <Line className={mb8} />
                <Box
                  baseline="none"
                  className={classes(style({ flexWrap: 'wrap' }))}
                  maxWidth={240}
                  flex
                >
                  {values.map((value: any, key: any) => {
                    if (value.id.body) {
                      return (
                        <Button
                          className={classes(mr4, mb4)}
                          label={value.id.body?.fullName}
                          baseline="primary"
                          size="md"
                          icon={
                            <i className={process.env.REACT_APP_GOOGLE_MATERIAL_ICONS}>close</i>
                          }
                          key={key}
                          onClick={() => {
                            $values.pop(key)
                          }}
                        />
                      )
                    }
                  })}
                </Box>
              </>
            }
            timeout={500}
          />
        </Box>
        <Line />
        <Box className={classes(STYLES.container, p12, pt4)} baseline="none" spaceBetween fullWidth>
          <Box />
          <Box baseline="none" spaceBetween>
            <Box />
            <Box column>
              <Button
                className={mr8}
                onClick={Modal.pop}
                label={GLOBAL_CONTENTS.close[local]}
                baseline="background"
                size="xs"
                square
              />
              <Button
                label={
                  patch.meta.isLoading
                    ? `${GLOBAL_CONTENTS.loading[local]} ...`
                    : GLOBAL_CONTENTS.save[local]
                }
                onClick={() => {
                  if (!patch.meta.isLoading) {
                    $patch
                      .patch({
                        url: to.url,
                        body: {
                          replace: 'access',
                          body: {
                            access: values.map((value: any) => {
                              return { id: value.id.id }
                            }),
                          },
                        },
                      })
                      .then(() => {
                        Notification.push({ label: 'Successfully updated!' })
                        Modal.pop()
                      })
                  }
                }}
                baseline="primary"
                size="xs"
                square
              />
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }),
)

const STYLES = stylesheet({
  container: {
    maxHeight: 420,
    overflow: 'auto',
    ...createMediaQuery['sm']({
      maxHeight: 360,
    }),
  },
})
